// src/components/trip/TabNavigation.tsx
import React from 'react';
import { Flex } from '@aws-amplify/ui-react';
import { ImageIcon, Users, HardDrive } from 'lucide-react';
import { formatFileSize } from '../../utils/formatters';

export type TabName = 'photos' | 'members' | 'storage';

interface TabNavigationProps {
  activeTab: TabName;
  photoCount: number;
  memberCount: number;
  storageUsed: number;
  onTabChange: (tabName: TabName) => void;
  userRole: string | null; // Add userRole to props
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  photoCount,
  memberCount,
  storageUsed,
  onTabChange,
  userRole
}) => {
  // Check if user is the creator - only creator should see storage tab
  const isCreator = userRole === 'CREATOR';

  return (
    <div className="tab-header">
      <button
        className={`tab-button ${activeTab === "photos" ? "active" : ""}`}
        onClick={() => onTabChange("photos")}
      >
        <Flex alignItems="center" gap="0.5rem">
          <ImageIcon size={18} />
          <span>Photos ({photoCount})</span>
        </Flex>
      </button>
      
      <button
        className={`tab-button ${activeTab === "members" ? "active" : ""}`}
        onClick={() => onTabChange("members")}
      >
        <Flex alignItems="center" gap="0.5rem">
          <Users size={18} />
          <span>Members ({memberCount})</span>
        </Flex>
      </button>
      
      {/* Only show storage tab for trip creator */}
      {isCreator && (
        <button
          className={`tab-button ${activeTab === "storage" ? "active" : ""}`}
          onClick={() => onTabChange("storage")}
        >
          <Flex alignItems="center" gap="0.5rem">
            <HardDrive size={18} />
            <span>Storage ({formatFileSize(storageUsed || 0)})</span>
          </Flex>
        </button>
      )}
    </div>
  );
};

export default TabNavigation;